import { Button, Tooltip } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { useLocalization } from '@ui-framework/index';

function ShowHideColumnsButton({ onClick, disabled = false, sx }) {
  const { formatMessage } = useLocalization();
  const label = formatMessage({
    id: 'SHOW_HIDE_COLUMNS_TITLE',
    defaultMessage: 'Show / Hide Columns',
  });

  const button = (
    <Button
      aria-label={label}
      onClick={onClick}
      size="small"
      variant="outlined"
      disabled={disabled}
      sx={{ minWidth: 'auto', px: 1, ...sx }}>
      <ViewColumnIcon />
    </Button>
  );

  return (
    <Tooltip title={label}>
      <span>{button}</span>
    </Tooltip>
  );
}

export default ShowHideColumnsButton;
